import { render, staticRenderFns } from "./UrgencyPlan.vue?vue&type=template&id=42f2c04c&scoped=true"
import script from "./UrgencyPlan.vue?vue&type=script&lang=js"
export * from "./UrgencyPlan.vue?vue&type=script&lang=js"
import style0 from "./UrgencyPlan.vue?vue&type=style&index=0&id=42f2c04c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f2c04c",
  null
  
)

export default component.exports